import { type ColorParams, DEFAULT_BG_TEXT_BORDER_COLOR, DEFAULT_BG_TEXT_COLOR } from './Color';
import { BorderAlignmentTypes } from './BorderAlignmentTypes';
import { type LineCapTypes } from './LineCapTypes';

export type TextBackgroundParams = {
    cornerRadius: number;
    color: ColorParams;
    spacingTop: number;
    spacingBottom: number;
    spacingLeft: number;
    spacingRight: number;
    borderColor?: ColorParams;
    borderWidth?: number;
    borderAlignment?: BorderAlignmentTypes;
    borderLineCap?: LineCapTypes;
    borderBrandColors?: number[];
};

export class TextBackground {
    public readonly state: 'ENABLED' | 'DISABLED';

    public readonly cornerRadius: number;

    public readonly color: ColorParams;

    public readonly spacingTop: number;

    public readonly spacingBottom: number;

    public readonly spacingLeft: number;

    public readonly spacingRight: number;

    public readonly borderColor: ColorParams;

    public readonly borderWidth: number;

    public readonly borderAlignment: BorderAlignmentTypes;

    public readonly borderLineCap: LineCapTypes | null;

    public readonly borderBrandColors: number[];

    constructor({
        state,
        cornerRadius,
        color,
        spacingTop,
        spacingBottom,
        spacingLeft,
        spacingRight,
        borderColor,
        borderWidth,
        borderAlignment,
        borderLineCap,
        borderBrandColors,
    }: TextBackgroundParams & { state?: 'ENABLED' | 'DISABLED' }) {
        this.state = state ?? 'ENABLED';
        this.cornerRadius = cornerRadius;
        this.color = color;
        this.spacingTop = spacingTop;
        this.spacingBottom = spacingBottom;
        this.spacingLeft = spacingLeft;
        this.spacingRight = spacingRight;
        this.borderColor = borderColor || DEFAULT_BG_TEXT_BORDER_COLOR;
        this.borderWidth = borderWidth || 0;
        this.borderAlignment = borderAlignment || BorderAlignmentTypes.INSIDE;
        this.borderLineCap = borderLineCap || null;
        this.borderBrandColors = borderBrandColors || [];
    }

    isActive() {
        return this.state === 'ENABLED';
    }

    toObject(): TextBackgroundParams | null {
        if (!this.isActive()) {
            return null;
        }

        return {
            cornerRadius: this.cornerRadius,
            color: this.color,
            spacingTop: this.spacingTop,
            spacingBottom: this.spacingBottom,
            spacingLeft: this.spacingLeft,
            spacingRight: this.spacingRight,
            borderColor: this.borderColor,
            borderWidth: this.borderWidth,
            borderAlignment: this.borderAlignment,
            borderLineCap: this.borderLineCap,
            borderBrandColors: this.borderBrandColors,
        };
    }
}

export const defaultTextBg = new TextBackground({
    state: 'ENABLED',
    color: DEFAULT_BG_TEXT_COLOR,
    cornerRadius: 0,
    spacingLeft: 10,
    spacingTop: 10,
    spacingRight: 10,
    spacingBottom: 10,
    borderColor: DEFAULT_BG_TEXT_BORDER_COLOR,
    borderWidth: 0,
    borderAlignment: BorderAlignmentTypes.INSIDE,
    borderLineCap: null,
    borderBrandColors: [],
});
